import styled from '@emotion/styled'
import {css} from '@emotion/react'
import {theme} from '../../theme'

// ─── Wrapper ──────────────────────────────────────────────────────────────────
// Gray background by default — active tab punches out with white + black border.

export const ToggleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  // border: 1px solid ${theme.colors.border.default};
  border-radius: ${({variant}) => (variant === 'pill' ? '999px' : '10px')};
  background: #f1f5ff;
  padding: 5px;
`

// ─── Active styles ────────────────────────────────────────────────────────────
// Active: white bg, black border on all sides (achieved via box-shadow so it
// sits on top of the wrapper border without shifting layout).

const activeTabStyles = ({isActive, variant}) =>
  isActive &&
  css`
    font-weight: ${theme.fontWeights.semibold};
    color: ${theme.colors.text.inverse};
    background: radial-gradient(
      57.14% 57.14% at 50% 92.86%,
      #5378fc 0%,
      #29355e 100%
    );
    border-radius: ${variant === 'pill' ? '999px' : '8px'};
    box-shadow: 0px 3px 5.3px 0px #0000002e;
    // z-index: 1;
  `

export const ToggleTab = styled.button`
  // font-family: ${theme.fonts.body};
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.semibold};
  color: #4c4c4c;
  background-color: transparent;
  border: none;
  padding: ${theme.space[1.5]} ${theme.space[3]};
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: ${theme.space[2]};
  transition: background-color ${theme.transitions.fast},
    color ${theme.transitions.fast};

  &:hover:not([aria-selected='true']) {
    color: ${theme.colors.text.primary};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${theme.colors.input.focusRing};
  }

  ${activeTabStyles}
`
